// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--s5WJt","not-enough-money":"_4f720283bf--not-enough-money--dR24s"};